import { Component, ContentChild, HostBinding, Input, TemplateRef } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

@Component({
    selector: 'app-common-grid',
    templateUrl: './common-grid.component.html',
    styleUrl: './common-grid.component.scss',
    standalone: false
})
export class CommonGridComponent {

  @Input() public cardTitle?: string;
  @Input() public cardIcon?: IconProp;
  @Input() public showLogo: boolean = true;

  @HostBinding('class')
  protected get layoutClass() {
    return `full-height-stack`;
  }

  @ContentChild('cardContent') protected cardContentTemplate?: TemplateRef<never>;
  @ContentChild('anyContent') protected anyContentTemplate?: TemplateRef<never>;

}
